let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dbQcW")).then(() => parcelRequire('bA1bg'));